import Vue from 'vue';
import { Decimal } from '@/models/decimal';

Vue.filter('convertDecimalValueToNumber', Decimal.convertValueToNumber);
